import React from 'react';
import type { DistributedOmit } from 'type-fest';
import type { ButtonProps } from '../components/Button';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import boltIcon from '../icons/non-prefilled/16x16/bolt.svg';
import * as styles from './UpgradeButton.module.scss';

type UpgradeButtonProps = DistributedOmit<ButtonProps, 'variant' | 'icon'> & {
  variant?: 'secondary' | 'link';
};

const UpgradeButton = ({
  size = 'regular',
  variant = 'secondary',
  ...props
}: UpgradeButtonProps) => {
  return (
    <div className={styles.upgradeButtonContainer}>
      <Button
        className={styles.upgradeButton}
        icon={
          <SVGIcon
            size={['micro', 'small'].includes(size) ? 'small' : 'regular'}
            className={styles.boltIcon}
          >
            {boltIcon}
          </SVGIcon>
        }
        size={size}
        variant={variant}
        {...props}
      />
    </div>
  );
};

export default UpgradeButton;
